import ClienteAvales from '../../../components/ui/Admin/AsignarAvalesComponents/ClienteAvales';

const AsignarAvalesUI = () => {
  return (
    <div className="min-h-screen bg-[var(--surface-page)]">
      <div className="mx-auto max-w-7xl px-4 py-6 md:px-6">
        <ClienteAvales />
      </div>
    </div>
  );
};

export default AsignarAvalesUI;
